// react
import React from "react";

// react-router-dom
import { BrowserRouter, Routes, Route } from "react-router-dom";

// styles
import "./App.css";

// context
import DeviceContextProvider from "./Context/deviceContext/deviceProvider";
import SnackbarContextProvider from "./Context/snackbarContext/snackbarProvider";

// components
import Registry from "./Pages/deviceRegistry/deviceRegistryComponent";
import Home from "./Pages/home/homeComponent";

// mui
import { ThemeProvider, createTheme } from "@mui/material/styles";

// mui theme
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: '"Poppins", sans-serif',
      textTransform: "none",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 626,
      md: 938,
      lg: 1239,
      xl: 1536,
    },
  },
});

// App-Component
const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarContextProvider>
        <DeviceContextProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:devEUI" element={<Registry />} />
            </Routes>
          </BrowserRouter>
        </DeviceContextProvider>
      </SnackbarContextProvider>
    </ThemeProvider>
  );
};

export default App;







